@if (showStartPicker || showEndPicker) {
  <div
    class="tw-fixed tw-inset-0 tw-bg-black tw-opacity-50 tw-z-10"
    (click)="togglePickersVisibility(PICKER_TYPE.BOTH)"
  ></div>
}
<!-- Product call, unresolved (#4720): these two triggers' tw-px-3 predates past/today's later
     responsive-padding pass (tw-px-6 xs:tw-px-4, both of which also carry an xs breakpoint step
     Future never got). Looks like the pass just never landed here rather than a deliberate
     choice to buy width for longer projected-date strings - confirm with design before
     changing either value. -->
<div class="tw-w-full tw-h-12 tw-flex tw-gap-2 tw-items-center" [appScrollLock]="isPickerOpen">
  <div
    class="tw-w-full tw-h-full tw-relative tw-bg-dt-surface-card left-round-border"
    [ngClass]="showStartPicker ? 'tw-z-20' : ''"
  >
    <div
      #startPickerTrigger
      class="tw-w-full tw-h-full tw-bg-dt-surface-elevated left-round-border tw-flex tw-gap-2 tw-whitespace-nowrap tw-items-center tw-px-3 tw-opacity-50 tw-cursor-not-allowed"
      appKeyboardActivatable
      [appKeyboardActivatableDisabled]="true"
    >
      <!-- Disabled: Future's start date is fixed, so it's announced as disabled and left out of
           the Tab order rather than a dead button. No (click) either: togglePickersVisibility
           would clear an unconfirmed To pick while its calendar still showed it (#6245). -->
      <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-2">
        <div class="tw-flex tw-gap-2 xs:tw-flex-col xs:tw-gap-0">
          <span class="tw-text-xs">From</span>
          <span class="tw-text-[13px]">{{ displayDateText().startDate }}</span>
        </div>
      </div>
    </div>
    <app-calendar
      #startPicker
      *ngIf="showStartPicker"
      [pickerType]="'start'"
      [dateRange]="initialDateRange()"
      [originalDateRange]="resetOriginalDateRange()"
      [timeDirectionOptions]="[LATER]"
      (dateChangeEvent)="onDateChange($event, 'startDate')"
      (confirmEvent)="onStartPickerConfirm()"
      (cancelEvent)="onPickerCancel()"
      class="date-picker future"
      [ngStyle]="
        isMobileScreen()
          ? {
              transform: 'translateX(' + startPickerTranslateValue + ')',
            }
          : {}
      "
    ></app-calendar>
  </div>

  <div
    class="tw-w-full tw-h-full tw-relative tw-bg-dt-surface-card right-round-border"
    [ngClass]="showEndPicker ? 'tw-z-20' : ''"
  >
    <div
      #endPickerTrigger
      class="tw-w-full tw-h-full right-round-border tw-flex tw-gap-2 tw-whitespace-nowrap tw-items-center tw-px-3 tw-shadow-modal-strong hover:tw-bg-dt-surface-elevated tw-cursor-pointer border-gradient-neuomorphic hover-border-future"
      [ngClass]="{
        'tw-bg-dt-surface-elevated border-active-future !tw-shadow-none': showEndPicker,
      }"
      (click)="togglePickersVisibility(PICKER_TYPE.END)"
      appKeyboardActivatable
      [appKeyboardActivatableExpanded]="showEndPicker"
      (appKeyboardActivatableActivate)="togglePickersVisibility(PICKER_TYPE.END)"
    >
      <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-2">
        <div class="tw-flex tw-gap-2 xs:tw-flex-col xs:tw-gap-0">
          <span class="tw-text-xs">To</span>
          <span class="tw-text-[13px]">{{ displayDateText().endDate }}</span>
        </div>
        <icon name="calendar" [size]="6" [currentColor]="'neutral-600'"></icon>
      </div>
    </div>
    <app-calendar
      #endPicker
      *ngIf="showEndPicker"
      [pickerType]="'end'"
      [dateRange]="initialDateRange()"
      [originalDateRange]="resetOriginalDateRange()"
      [timeDirectionOptions]="[LATER]"
      [currentDateFilter]="getCurrentDateRangeFilter"
      (dateChangeEvent)="onDateChange($event, 'endDate')"
      (dateRangePreviewEvent)="onDatePreview($event)"
      (confirmEvent)="onEndPickerConfirm()"
      (cancelEvent)="onPickerCancel()"
      class="date-picker future tw-right-0 xs:tw-right-auto"
      [ngStyle]="
        isMobileScreen()
          ? {
              transform: 'translateX(' + endPickerTranslateValue + ')',
            }
          : {}
      "
    ></app-calendar>
  </div>
</div>
